/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT DELETE USER : STYLES --------------- ++++++++++ */
export default theme =>({
    deleteuser: {
        extend: theme.modal.form,
        maxWidth: pxToEm(432),
        '& .name-deleteuser':{
            '& .bodycopy':{
                marginTop:pxToEm(72),
                textAlign: 'center'
            }
        },
        '& .name-ctas':{
            marginTop:pxToEm(72)
        }
    }
});
